import { useEffect, useState } from 'react'
import { useAuth } from '../App'
import { supabase } from '../lib/supabase'
import { buildLayeringPopularityCounts } from '../lib/layeringModes'

const EMPTY_COUNTS = new Map()

export function useLayeringPopularity(enabled = false) {
  const { user } = useAuth()
  const [snapshot, setSnapshot] = useState({ userId: '', counts: EMPTY_COUNTS })

  useEffect(() => {
    let active = true
    if (!enabled || !user?.id) {
      setSnapshot({ userId: user?.id || '', counts: EMPTY_COUNTS })
      return () => { active = false }
    }

    supabase.from('pairings')
      .select('fragrance_id,suggested_pairings')
      .eq('user_id', user.id)
      .then(({ data, error }) => {
        if (!active || error) return
        setSnapshot({ userId: user.id, counts: buildLayeringPopularityCounts(data || []) })
      })

    return () => { active = false }
  }, [enabled, user?.id])

  return enabled && snapshot.userId === user?.id ? snapshot.counts : EMPTY_COUNTS
}
